<template>
    <div class="w-100">

        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
        </div>

        <!-- Alert box -->
        <div v-show="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-care-plan" action="care-plans/store" class="add-care-plan add-record">           
            
            <div class="card" v-if="currentStep == 1" title="Evaluation">
                <div class="card-header">
                    <h3 class="card-title">Evaluation</h3>
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="card mb-4">
                                <div class="table-responsive">
                                    <table class="table table-vcenter card-table">
                                        <thead>
                                            <tr>
                                                <th>Section</th>
                                                <th>Need</th>
                                                <th>Goal / Aim</th>                                                    
                                                <th>Staff Intervention</th>
                                                <th class="wFixed">Goal Met</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="align-top">Medical Diagnosis</td>
                                                <td class="align-top">{{ step[0].medicalDiagnosisNeed }}</td>
                                                <td class="align-top">{{ step[0].medicalDiagnosisGoalAim  }}</td>
                                                <td class="align-top">{{ step[0].medicalDiagnosisStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].medicalDiagnosisGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].medicalDiagnosisGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top">Relatives Notifications</td>
                                                <td class="align-top">{{ step[0].relativesNotificationsNeed }}</td>
                                                <td class="align-top">{{ step[0].relativesNotificationsGoalAim }}</td>
                                                <td class="align-top">{{ step[0].relativesNotificationsStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].relativesNotificationsGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].relativesNotificationsGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top">Physical Activities</td>
                                                <td class="align-top">{{ step[0].physicalActivitiesNeed }}</td>
                                                <td class="align-top">{{ step[0].physicalActivitiesGoalAim }}</td>
                                                <td class="align-top">{{ step[0].physicalActivitiesStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].physicalActivitiesGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].physicalActivitiesGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Mobility</span>                                                    
                                                    <small class="form-hint">/Transfer Aids needed</small>
                                                </td>
                                                <td class="align-top">{{ step[0].mobilityAidsNeed }}</td>
                                                <td class="align-top">{{ step[0].mobilityAidsGoalAim }}</td>
                                                <td class="align-top">{{ step[0].mobilityAidsStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].mobilityAidsGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].mobilityAidsGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Functional status</span>                                                    
                                                    <small class="form-hint">ADL self-performance</small>
                                                </td>
                                                <td class="align-top">{{ step[0].functionalStatusNeed }}</td>
                                                <td class="align-top">{{ step[0].functionalStatusGoalAim }}</td>
                                                <td class="align-top">{{ step[0].functionalStatusStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].functionalStatusGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].functionalStatusGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Showering and washing</span>                                                    
                                                    <small class="form-hint">including hair wash</small>
                                                </td>
                                                <td class="align-top">{{ step[0].showeringWashingNeed }}</td>
                                                <td class="align-top">{{ step[0].showeringWashingGoalAim }}</td>
                                                <td class="align-top">{{ step[0].showeringWashingStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].showeringWashingGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].showeringWashingGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Grooming/Dressing</span>                                                    
                                                    <small class="form-hint">including need for make-up, shaving</small>
                                                </td>
                                                <td class="align-top">{{ step[0].groomingDressingNeed }}</td>
                                                <td class="align-top">{{ step[0].groomingDressingGoalAim }}</td>
                                                <td class="align-top">{{ step[0].groomingDressingStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].groomingDressingGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].groomingDressingGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Restraint or enabler requirement</span>                                                    
                                                    <small class="form-hint">(complete Restraint assessment)</small>
                                                </td>
                                                <td class="align-top">{{ step[0].restraintRequirementNeed }}</td>
                                                <td class="align-top">{{ step[0].restraintRequirementGoalAim }}</td>
                                                <td class="align-top">{{ step[0].restraintRequirementStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].restraintRequirementGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].restraintRequirementGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Cognitive Patterns Skills</span>                                                    
                                                    <small class="form-hint">for daily decision making</small>
                                                </td>
                                                <td class="align-top">{{ step[0].cognitivePatternsNeed }}</td>
                                                <td class="align-top">{{ step[0].cognitivePatternsGoalAim }}</td>
                                                <td class="align-top">{{ step[0].cognitivePatternsStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].cognitivePatternsGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].cognitivePatternsGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Memory/Recall Ability</span>                                                    
                                                    <small class="form-hint">Long- term and short-term memory</small>
                                                </td>
                                                <td class="align-top">{{ step[0].memoryRecallNeed }}</td>
                                                <td class="align-top">{{ step[0].memoryRecallGoalAim }}</td>
                                                <td class="align-top">{{ step[0].memoryRecallStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].memoryRecallGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].memoryRecallGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Mood/ Behaviour</span>                                                    
                                                    <small class="form-hint">Depression, anxiety, - Behaviour symptoms - Behavioural Chart</small>
                                                </td>
                                                <td class="align-top">{{ step[0].moodBehaviourNeed }}</td>
                                                <td class="align-top">{{ step[0].moodBehaviourGoalAim }}</td>
                                                <td class="align-top">{{ step[0].moodBehaviourStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].moodBehaviourGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].moodBehaviourGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Psychosocial well-being</span>                                                    
                                                    <small class="form-hint">Social relationship - Sense of involvement</small>
                                                </td>
                                                <td class="align-top">{{ step[0].phychosocialWellbeingNeed }}</td>
                                                <td class="align-top">{{ step[0].phychosocialWellbeingGoalAim }}</td>
                                                <td class="align-top">{{ step[0].phychosocialWellbeingStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].phychosocialWellbeingGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].phychosocialWellbeingGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="ms-3 me-2">Health conditions</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].healthConditionsNeed }}</td>
                                                <td class="align-top">{{ step[0].healthConditionsGoalAim }}</td>
                                                <td class="align-top">{{ step[0].healthConditionsStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].healthConditionsGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].healthConditionsGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="ms-3 me-2">Pain</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].painNeed }}</td>
                                                <td class="align-top">{{ step[0].painGoalAim }}</td>
                                                <td class="align-top">{{ step[0].painStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].painGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].painGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="ms-3 me-2">Falls</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].fallsNeed }}</td>
                                                <td class="align-top">{{ step[0].fallsGoalAim }}</td>
                                                <td class="align-top">{{ step[0].fallsStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].fallsGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].fallsGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="ms-3 me-2">Pain Falls Assessment</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].painFallsAssessmentNeed }}</td>
                                                <td class="align-top">{{ step[0].painFallsAssessmentGoalAim }}</td>
                                                <td class="align-top">{{ step[0].painFallsAssessmentStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].painFallsAssessmentGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].painFallsAssessmentGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Nutritional Status</span>                                                    
                                                    <small class="form-hint">Food and Fluids - Feeding - Complete dietary profile.</small>
                                                </td>
                                                <td class="align-top">{{ step[0].nutritionalStatusNeed }}</td>
                                                <td class="align-top">{{ step[0].nutritionalStatusGoalAim }}</td>
                                                <td class="align-top">{{ step[0].nutritionalStatusStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].nutritionalStatusGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].nutritionalStatusGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Continence / Elimination</span>                                                    
                                                    <small class="form-hint">Bladder/Bowel - Toileting regime</small>
                                                </td>
                                                <td class="align-top">{{ step[0].continenceEliminationNeed }}</td>
                                                <td class="align-top">{{ step[0].continenceEliminationGoalAim }}</td>
                                                <td class="align-top">{{ step[0].continenceEliminationStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].continenceEliminationGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].continenceEliminationGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Night care</span>                                                    
                                                    <small class="form-hint">Sleeping patterns - Special requirements such as light on, door open or closed</small>
                                                </td>
                                                <td class="align-top">{{ step[0].nightCareNeed }}</td>
                                                <td class="align-top">{{ step[0].nightCareGoalAim }}</td>
                                                <td class="align-top">{{ step[0].nightCareStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].nightCareGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].nightCareGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="ms-3 me-2">Skin care / Skin integrity</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].skinConditionNeed }}</td>
                                                <td class="align-top">{{ step[0].skinConditionGoalAim }}</td>
                                                <td class="align-top">{{ step[0].skinConditionStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].skinConditionGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].skinConditionGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="ms-3 me-2">Pressure Area Risk</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].pressureAreaNeed }}</td>
                                                <td class="align-top">{{ step[0].pressureAreaGoalAim }}</td>
                                                <td class="align-top">{{ step[0].pressureAreaStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].pressureAreaGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].pressureAreaGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="ms-3 me-2">Foot problems</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].footProblemsNeed }}</td>
                                                <td class="align-top">{{ step[0].footProblemsGoalAim }}</td>
                                                <td class="align-top">{{ step[0].footProblemsStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].footProblemsGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].footProblemsGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            <!--
                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Skin > Skin Assessment Completed</span>                                                    
                                                    <small class="form-hint"></small>
                                                </td>
                                                <td class="align-top">{{ step[0].skinAssessmentCompletedNeed }}</td>
                                                <td class="align-top">{{ step[0].skinAssessmentCompletedGoalAim }}</td>
                                                <td class="align-top">{{ step[0].skinAssessmentCompletedStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].skinAssessmentCompletedGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].skinAssessmentCompletedGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>
                                            -->

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Activity pursuit</span>                                                    
                                                    <small class="form-hint">Activity preferences and involvement</small>
                                                </td>
                                                <td class="align-top">{{ step[0].activityPursuitNeed }}</td>
                                                <td class="align-top">{{ step[0].activityPursuitGoalAim }}</td>
                                                <td class="align-top">{{ step[0].activityPursuitStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].activityPursuitGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].activityPursuitGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="align-top">
                                                    <span class="me-2">Social</span>                                                    
                                                    <small class="form-hint">Spirituality / Religion / Culture</small>
                                                </td>
                                                <td class="align-top">{{ step[0].socialSpiritualityNeed }}</td>
                                                <td class="align-top">{{ step[0].socialSpiritualityGoalAim }}</td>
                                                <td class="align-top">{{ step[0].socialSpiritualityStaffIntervention }}</td>
                                                <td class="align-top">                                                    
                                                    <div class="form-check form-switch">
                                                        <input class="form-check-input" type="checkbox" v-model="step[0].socialSpiritualityGoalMet"/>                                                                                                        
                                                    </div>
                                                    <div class="invalid-feedback" :class="{'d-block': v$.step[0].socialSpiritualityGoalMet.$invalid }">Invalid feedback</div>
                                                </td>
                                            </tr>

                                             

                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">                            
                            
                            <div class="mb-3">
                                <div class="form-label">Evaluation</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Evaluation"
                                    value=""
                                    spellcheck="false"
                                    name="evaluation"
                                    v-model="step[0].evaluation"
                                    :class="{
                                        'is-invalid': v$.step[0].evaluation.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].evaluation.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Did the plan met its overall goal?</div>
                                <label v-for="option in resultOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="result" :value="option" v-model="step[0].evaluationResult" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].evaluationResult.$invalid}">Invalid feedback</div>
                            </div>
                            
                            
                            <div class="mb-3">
                                <div class="form-label">Signature</div>                     
                                <input
                                    type="text"
                                    class="form-control w-75 mt-2"
                                    name="reviewerSignature"
                                    placeholder="Enter your full name"
                                    v-model="step[0].reviewerSignature"
                                    :class="{'is-invalid': v$.step[0].reviewerSignature.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].reviewerSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>                         

                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                        </div>
                    </div>

                </div>
                
                <div class="card-footer justify-content-end">                    
                    <p class="d-flex align-items-center mb-0">
                        
                        <a :href="'/care-plans/' + carePlanID" class="p-2 mx-3 d-block back-btn" id="last-back-btn">Cancel</a>
                        <a @click="onClickNext()" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
                
            </div>

        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import Multiselect from 'vue-multiselect';
import moment from 'moment';

export default {
    name: "longTermCarePlanReviewComponent",
    props: ["progressBar", "pageTitle", "residentId", "userId", "carePlan", "operation"], // vue can read kebab props as camel cased vars
    components: { Multiselect },
    setup() {
        return {v$: useVuelidate()};
    },
    data() {             
        var carePlanObject = JSON.parse(this.carePlan); 
        
        carePlanObject['long_term_care_plan'] = JSON.parse(carePlanObject['long_term_care_plan']);

        // Returs empty string when object doesn't exist 
        // options - array | string
        function returnValueFromObject(fieldName, defaultValue = "", options) {      
            // Editing
            if (!_.isEmpty(carePlanObject)) {
                return carePlanObject['long_term_care_plan'][fieldName] ?? defaultValue;
            } else {
                return defaultValue;
            }
        }

        return {
            currentStep: 1, 
            maxStep: 1,
            percentageComplete: 0,
            errors: 0,
            trueFalseOptions: [true,false],
            resultOptions: ['Met', 'Not Met', 'Partially Met'],
            endpoint: location.protocol + "//" + window.location.host + "/api/care-plans/" + carePlanObject.id + '/' + process.env.MIX_API_KEY,
            carePlanID: carePlanObject.id,
            step: [
                // Step 1 - Evaluation
                {   medicalDiagnosisNeed: returnValueFromObject('medicalDiagnosisNeed'),
                    medicalDiagnosisGoalAim: returnValueFromObject('medicalDiagnosisGoalAim'),
                    medicalDiagnosisStaffIntervention: returnValueFromObject('medicalDiagnosisStaffIntervention'),
                    medicalDiagnosisGoalMet: returnValueFromObject('medicalDiagnosisGoalMet'),
                    
                    relativesNotificationsNeed: returnValueFromObject('relativesNotificationsNeed'),
                    relativesNotificationsGoalAim: returnValueFromObject('relativesNotificationsGoalAim'),
                    relativesNotificationsStaffIntervention: returnValueFromObject('relativesNotificationsStaffIntervention'),
                    relativesNotificationsGoalMet: returnValueFromObject('relativesNotificationsGoalMet'),

                    physicalActivitiesNeed: returnValueFromObject('physicalActivitiesNeed'),
                    physicalActivitiesGoalAim: returnValueFromObject('physicalActivitiesGoalAim'),
                    physicalActivitiesStaffIntervention: returnValueFromObject('physicalActivitiesStaffIntervention'),
                    physicalActivitiesGoalMet: returnValueFromObject('physicalActivitiesGoalMet'),                    
                    
                    mobilityAidsNeed: returnValueFromObject('mobilityAidsNeed'),
                    mobilityAidsGoalAim: returnValueFromObject('mobilityAidsGoalAim'),
                    mobilityAidsStaffIntervention: returnValueFromObject('mobilityAidsStaffIntervention'),
                    mobilityAidsGoalMet: returnValueFromObject('mobilityAidsGoalMet'),                    
                    
                    functionalStatusNeed: returnValueFromObject('functionalStatusNeed'),
                    functionalStatusGoalAim: returnValueFromObject('functionalStatusGoalAim'),
                    functionalStatusStaffIntervention: returnValueFromObject('functionalStatusStaffIntervention'),
                    functionalStatusGoalMet: returnValueFromObject('functionalStatusGoalMet'),                    
                    
                    showeringWashingNeed: returnValueFromObject('showeringWashingNeed'),
                    showeringWashingGoalAim: returnValueFromObject('showeringWashingGoalAim'),
                    showeringWashingStaffIntervention: returnValueFromObject('showeringWashingStaffIntervention'),
                    showeringWashingGoalMet: returnValueFromObject('showeringWashingGoalMet'),                    
                    
                    groomingDressingNeed: returnValueFromObject('groomingDressingNeed'),
                    groomingDressingGoalAim: returnValueFromObject('groomingDressingGoalAim'),
                    groomingDressingStaffIntervention: returnValueFromObject('groomingDressingStaffIntervention'),
                    groomingDressingGoalMet: returnValueFromObject('groomingDressingGoalMet'),                    
                    
                    restraintRequirementNeed: returnValueFromObject('restraintRequirementNeed'),
                    restraintRequirementGoalAim: returnValueFromObject('restraintRequirementGoalAim'),
                    restraintRequirementStaffIntervention: returnValueFromObject('restraintRequirementStaffIntervention'),
                    restraintRequirementGoalMet: returnValueFromObject('restraintRequirementGoalMet'),

                    cognitivePatternsNeed: returnValueFromObject('cognitivePatternsNeed'),
                    cognitivePatternsGoalAim: returnValueFromObject('cognitivePatternsGoalAim'),
                    cognitivePatternsStaffIntervention: returnValueFromObject('cognitivePatternsStaffIntervention'),
                    cognitivePatternsGoalMet: returnValueFromObject('cognitivePatternsGoalMet'),                    
                    
                    memoryRecallNeed: returnValueFromObject('memoryRecallNeed'),
                    memoryRecallGoalAim: returnValueFromObject('memoryRecallGoalAim'),
                    memoryRecallStaffIntervention: returnValueFromObject('memoryRecallStaffIntervention'),
                    memoryRecallGoalMet: returnValueFromObject('memoryRecallGoalMet'),

                    moodBehaviourNeed: returnValueFromObject('moodBehaviourNeed'),
                    moodBehaviourGoalAim: returnValueFromObject('moodBehaviourGoalAim'),
                    moodBehaviourStaffIntervention: returnValueFromObject('moodBehaviourStaffIntervention'),
                    moodBehaviourGoalMet: returnValueFromObject('moodBehaviourGoalMet'),                    
                    
                    phychosocialWellbeingNeed: returnValueFromObject('phychosocialWellbeingNeed'),
                    phychosocialWellbeingGoalAim: returnValueFromObject('phychosocialWellbeingGoalAim'),
                    phychosocialWellbeingStaffIntervention: returnValueFromObject('phychosocialWellbeingStaffIntervention'),
                    phychosocialWellbeingGoalMet: returnValueFromObject('phychosocialWellbeingGoalMet'),                    
                    
                    healthConditionsNeed: returnValueFromObject('healthConditionsNeed'),
                    healthConditionsGoalAim: returnValueFromObject('healthConditionsGoalAim'),
                    healthConditionsStaffIntervention: returnValueFromObject('healthConditionsStaffIntervention'),
                    healthConditionsGoalMet: returnValueFromObject('healthConditionsGoalMet'),                    

                    painNeed: returnValueFromObject('painNeed'),
                    painGoalAim: returnValueFromObject('painGoalAim'),
                    painStaffIntervention: returnValueFromObject('painStaffIntervention'),
                    painGoalMet: returnValueFromObject('painGoalMet'),                    
                    
                    fallsNeed: returnValueFromObject('fallsNeed'),
                    fallsGoalAim: returnValueFromObject('fallsGoalAim'),
                    fallsStaffIntervention: returnValueFromObject('fallsStaffIntervention'),
                    fallsGoalMet: returnValueFromObject('fallsGoalMet'),                    
                    
                    painFallsAssessmentNeed: returnValueFromObject('painFallsAssessmentNeed'),
                    painFallsAssessmentGoalAim: returnValueFromObject('painFallsAssessmentGoalAim'),
                    painFallsAssessmentStaffIntervention: returnValueFromObject('painFallsAssessmentStaffIntervention'),
                    painFallsAssessmentGoalMet: returnValueFromObject('painFallsAssessmentGoalMet'),                    
                    
                    nutritionalStatusNeed: returnValueFromObject('nutritionalStatusNeed'),
                    nutritionalStatusGoalAim: returnValueFromObject('nutritionalStatusGoalAim'),
                    nutritionalStatusStaffIntervention: returnValueFromObject('nutritionalStatusStaffIntervention'),
                    nutritionalStatusGoalMet: returnValueFromObject('nutritionalStatusGoalMet'), 

                    continenceEliminationNeed: returnValueFromObject('continenceEliminationNeed'),
                    continenceEliminationGoalAim: returnValueFromObject('continenceEliminationGoalAim'),
                    continenceEliminationStaffIntervention: returnValueFromObject('continenceEliminationStaffIntervention'),
                    continenceEliminationGoalMet: returnValueFromObject('continenceEliminationGoalMet'),           
                    
                    nightCareNeed: returnValueFromObject('nightCareNeed'),
                    nightCareGoalAim: returnValueFromObject('nightCareGoalAim'),
                    nightCareStaffIntervention: returnValueFromObject('nightCareStaffIntervention'),
                    nightCareGoalMet: returnValueFromObject('nightCareGoalMet'),           
                    
                    dentalStatusNeed: returnValueFromObject('dentalStatusNeed'),
                    dentalStatusGoalAim: returnValueFromObject('dentalStatusGoalAim'),
                    dentalStatusStaffIntervention: returnValueFromObject('dentalStatusStaffIntervention'),
                    dentalStatusGoalMet: returnValueFromObject('dentalStatusGoalMet'),  
                    
                    skinConditionNeed: returnValueFromObject('skinConditionNeed'),
                    skinConditionGoalAim: returnValueFromObject('skinConditionGoalAim'),
                    skinConditionStaffIntervention: returnValueFromObject('skinConditionStaffIntervention'),
                    skinConditionGoalMet: returnValueFromObject('skinConditionGoalMet'),  

                    pressureAreaNeed: returnValueFromObject('pressureAreaNeed'),
                    pressureAreaGoalAim: returnValueFromObject('pressureAreaGoalAim'),
                    pressureAreaStaffIntervention: returnValueFromObject('pressureAreaStaffIntervention'),
                    pressureAreaGoalMet: returnValueFromObject('pressureAreaGoalMet'),  

                    footProblemsNeed: returnValueFromObject('footProblemsNeed'),
                    footProblemsGoalAim: returnValueFromObject('footProblemsGoalAim'),
                    footProblemsStaffIntervention: returnValueFromObject('footProblemsStaffIntervention'),
                    footProblemsGoalMet: returnValueFromObject('footProblemsGoalMet'),  

                    skinAssessmentCompletedNeed: returnValueFromObject('skinAssessmentCompletedNeed'),
                    skinAssessmentCompletedGoalAim: returnValueFromObject('skinAssessmentCompletedGoalAim'),
                    skinAssessmentCompletedStaffIntervention: returnValueFromObject('skinAssessmentCompletedStaffIntervention'),
                    skinAssessmentCompletedGoalMet: returnValueFromObject('skinAssessmentCompletedGoalMet'),  

                    activityPursuitNeed: returnValueFromObject('activityPursuitNeed'),
                    activityPursuitGoalAim: returnValueFromObject('activityPursuitGoalAim'),
                    activityPursuitStaffIntervention: returnValueFromObject('activityPursuitStaffIntervention'),
                    activityPursuitGoalMet: returnValueFromObject('activityPursuitGoalMet'),

                    socialSpiritualityNeed: returnValueFromObject('socialSpiritualityNeed'),
                    socialSpiritualityGoalAim: returnValueFromObject('socialSpiritualityGoalAim'),
                    socialSpiritualityStaffIntervention: returnValueFromObject('socialSpiritualityStaffIntervention'),
                    socialSpiritualityGoalMet: returnValueFromObject('socialSpiritualityGoalMet'),

                    evaluation: returnValueFromObject('evaluation'),
                    reviewerSignature: returnValueFromObject('reviewerSignature'),
                    evaluationResult: carePlanObject['evaluation_result'],

                },
            ],
        };
    },
    validations() {

        // Custom Validators
        const inArray = (array) => (value) => array.includes(value) || !helpers.req(value);
        const isDateFormat = (value) => value.match("^$|((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
        const isTimeFormat = (value) => value.match("^$|^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$") || !helpers.req(value);
        const isTextWithSpecialCharacters = (value) => value.match("^[a-zA-Z0-9_ !@#$&%^*()`.+,/\\-\r\n\s\'\"]*$") || !helpers.req(value);
        const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s\'\"]*$") || !helpers.req(value);

        const dateType = {
            required, 
            isDateFormat, 
            $lazy: true, 
            $autoDirty: true
        };
        
        const timeType = {
            required, 
            isTimeFormat, 
            $lazy: true, 
            $autoDirty: true
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3,maximum = 191, isRequired = false, allowSpecial = false) {
            if (allowSpecial) {
                var rule = {
                    required,
                    isTextWithSpecialCharacters,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };
            } else {
                var rule = {
                    required,
                    isTextWithSpace,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };                
            }

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }

        // ARRAY TYPES        
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                // $lazy: true,
                // $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }
        
        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);                
            delete validations['required'];
            
            return validations;
        };

        return {
            step: [
                // Step 1 - Evaluation
                {   
                    medicalDiagnosisGoalMet: inOptions(this.trueFalseOptions),
                    relativesNotificationsGoalMet: inOptions(this.trueFalseOptions),
                    physicalActivitiesGoalMet: inOptions(this.trueFalseOptions),
                    mobilityAidsGoalMet: inOptions(this.trueFalseOptions),
                    functionalStatusGoalMet: inOptions(this.trueFalseOptions),
                    showeringWashingGoalMet: inOptions(this.trueFalseOptions),
                    groomingDressingGoalMet: inOptions(this.trueFalseOptions),
                    restraintRequirementGoalMet: inOptions(this.trueFalseOptions),
                    cognitivePatternsGoalMet: inOptions(this.trueFalseOptions),
                    memoryRecallGoalMet: inOptions(this.trueFalseOptions),
                    moodBehaviourGoalMet: inOptions(this.trueFalseOptions),
                    phychosocialWellbeingGoalMet: inOptions(this.trueFalseOptions),
                    healthConditionsGoalMet: inOptions(this.trueFalseOptions),
                    painGoalMet: inOptions(this.trueFalseOptions),
                    fallsGoalMet: inOptions(this.trueFalseOptions),
                    painFallsAssessmentGoalMet: inOptions(this.trueFalseOptions),
                    nutritionalStatusGoalMet: inOptions(this.trueFalseOptions),
                    continenceEliminationGoalMet: inOptions(this.trueFalseOptions),
                    nightCareGoalMet: inOptions(this.trueFalseOptions),
                    dentalStatusGoalMet: inOptions(this.trueFalseOptions),
                    skinConditionGoalMet: inOptions(this.trueFalseOptions),
                    pressureAreaGoalMet: inOptions(this.trueFalseOptions),
                    footProblemsGoalMet: inOptions(this.trueFalseOptions),
                    // skinAssessmentGoalMet: inOptions(this.trueFalseOptions),
                    activityPursuitGoalMet: inOptions(this.trueFalseOptions),
                    socialSpiritualityGoalMet: inOptions(this.trueFalseOptions),

                    evaluationResult: inOptions(this.resultOptions),       
                    evaluation:  text(3, 500, true, true), 
                    evaluationResult: inOptions(this.resultOptions),       
                    reviewerSignature: text(3, 191, true)
                },
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {        
            
            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {

                // All steps
                if (this.currentStep < this.maxStep) {                           
                    // Proceed to next step
                    this.currentStep++;

                // Final step
                } else if (this.currentStep == this.maxStep) {
                    
                    // Initialize alerts and toast notifications for displaying message  
                    const toastError = Swal.mixin({          
                            toast: true,                
                            position: 'top-end', 
                            showConfirmButton: true, 
                        });  
                    const alertSuccess = Swal.mixin({                          
                            position: 'center', 
                            showConfirmButton: true, 
                            timer: 3000,
                            timerProgressBar: true,
                        });  

                    // Show button spinner
                    document.getElementById('submit-btn').innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById('submit-btn').disabled  = true;
                    document.getElementById('last-back-btn').setAttribute('style', 'display:none !important');

                   
                    var formData = {};
                    
                    // Loop through all steps
                    for(let i=0; i < this.maxStep; i++){ 
                        // Loop through all the step fields
                        for ( const [key,value] of Object.entries( this.step[i] ) ) {   
                            formData[key] = value;                     
                        }
                    }

                    // Add residentID, userID, type and interventions fields
                    formData['residentID'] = this.residentId;
                    formData['userID'] = this.userId;
                    formData['type'] = "Short Term";             
                    formData['updateType'] = 'review';
                    
                    this.updateCarePlan(formData, toastError, alertSuccess);
                   
                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },


        updateCarePlan: function(formData, toastError, alertSuccess) {           
            // Call the update endpoint
            axios.put(this.endpoint, formData)
                .then((response) => {
                    if(response.data.error == 403){                                
                        console.log('Bad Request');
                        console.log(response.data);
                        
                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({ 
                            type: 'warning', 
                            title: 'The input fields are malformed and cant be processed.' 
                        }); 
                    } else {
                        if(response.data.id == null){
                            console.log('Validation Error');
                            console.log(response.data);
                            
                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                            toastError.fire({ 
                                type: 'warning', 
                                title: 'There are validation errors found on the form.'
                            });                             
                        }
                        else{
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was updated
                            this.formSuccess = true;
                            window.residentId = this.residentId;

                            alertSuccess.fire({
                                title: "Success!",
                                text: "The long term care plan has been reviewed.",
                                icon: "success",                           
                            }).then(function(){
                                window.location = "/residents/"+window.residentId+"/care-plans?type=Long+Term";
                            }); 
                        }
                    }                                        
                    
                })
                .catch((err) => {                            
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({ type: 'error', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                })
        }        
        
    },
};
</script>
